export type ChatState = {
	userId: string;
	username: string;
	userEmail: string;
	appName: string;
	appSupportEmail: string;
	appTeamName: string;
	chatOpen: boolean;
	isFirstTimeChatOpened: boolean;
	assistantTitle: string;
	authReady: boolean;
	locale: string;
	language: string;
};

export const initialChatState = {
	userId: "",
	username: "",
	userEmail: "",
	appName: "",
	appSupportEmail: "",
	appTeamName: "",
	chatOpen: false,
	isFirstTimeChatOpened: true,
	assistantTitle: "",
	authReady: false,
	locale: "",
	language: "",
} as ChatState;

export type ChatContextType = {
	chatState: ChatState;
	analyticsEnabled: boolean;
	setPartialChatState: (state: Partial<ChatState>) => void;
	pushContextMessage: (message: string) => void;
};
